<script lang="ts">
	import type { ServiceStatus } from '../../AppTypes';
	import { overallHeadline, statusBg } from '../../statusUtils';

	export let status: ServiceStatus;
</script>

<div class="rounded-xl {statusBg(status)} text-white px-6 py-5 flex items-center gap-4 shadow-sm">
	<svg class="w-8 h-8 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
		{#if status === 'operational'}
			<path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
		{:else if status === 'maintenance'}
			<path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63" />
		{:else}
			<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
		{/if}
	</svg>
	<h1 class="status-headline text-xl sm:text-2xl font-semibold">{overallHeadline(status)}</h1>
</div>
